import { createApp } from "vue"
import { createMetaManager } from "vue-meta"
import store from "./modules"
import axios from "axios"
import i18n from "@/lng/i18n"
import { router } from "./router"
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import '@vuepic/vue-datepicker/dist/main.css'
import 'unfonts.css'
import root from "./App.vue"
import { library } from "@fortawesome/fontawesome-svg-core";
import msalPlugin from './msal.plugin';
import globalMixin from './utils/globalMixin';
import './css/webportal.css';

import {
    faUser,
    faHome,
    faCashRegister,
    faMoneyBills,
    faInfoCircle,
    faGaugeHigh,
    faTrashCan,
    faPlusSquare,
    faPencil,
    faScroll,
    faReceipt,
    faCut,
    faAt,
    faPlus,
    faDoorOpen,
    faHourglass,
    faWrench,
    faScrewdriverWrench,
    faBell,
    faChartPie,
    faNetworkWired,
    faTerminal,
    faFloppyDisk,
    faDisplay,
    faMoneyBillTransfer,
    faBalanceScale,
    faCreditCard,
    faGlobe,
    faFilter,
    faBook,
    faGear,
    faKey,
    faDownload,
    faTruck,
    faUserSlash,
    faTag,
    faFile,
    faCheck,
    faDollarSign,
    faFaceSmile,
    faCheckDouble,
    faHandHoldingDollar,
    faHashtag,
    faDesktop,
    faPercent,
    faBoxesStacked,
    faUpload,
    faStar,
    faCircleExclamation,
    faEquals,
    faArrowTrendUp,
    faPaperPlane,
    faPenToSquare,
    faLock,
    faLockOpen,
    faStore,
    faQrcode,
    faCoins,
    faMagnifyingGlass,
    faUserPlus,
    faShieldHalved,
    faRobot,
    faLink,
    faLinkSlash,
    faXmark,
    faIdBadge,
    faLandmark,
    faAngleRight,
    faAngleLeft,
    faChevronUp,
    faChevronDown,
    faUserGear,
    faUserSecret,
    faEarthAmericas,
    faEllipsis,
    faGears,
    faRotateRight,
    faRotateLeft,
    faQuestionCircle,
    faMap,
} from "@fortawesome/free-solid-svg-icons";

import vuetify from './plugins/vuetify'

library.add(
    faUser,
    faHome,
    faCashRegister,
    faMoneyBills,
    faInfoCircle,
    faGaugeHigh,
    faTrashCan,
    faPlusSquare,
    faPencil,
    faScroll,
    faReceipt,
    faCut,
    faAt,
    faPlus,
    faDoorOpen,
    faHourglass,
    faWrench,
    faScrewdriverWrench,
    faBell,
    faChartPie,
    faNetworkWired,
    faTerminal,
    faFloppyDisk,
    faDisplay,
    faMoneyBillTransfer,
    faBalanceScale,
    faCreditCard,
    faGlobe,
    faFilter,
    faBook,
    faGear,
    faKey,
    faDownload,
    faTruck,
    faUserSlash,
    faTag,
    faFile,
    faCheck,
    faDollarSign,
    faCheckDouble,
    faHandHoldingDollar,
    faFaceSmile,
    faHashtag,
    faDesktop,
    faPercent,
    faUpload,
    faStar,
    faHome,
    faCircleExclamation,
    faEquals,
    faArrowTrendUp,
    faPaperPlane,
    faPenToSquare,
    faLock,
    faLockOpen,
    faFaceSmile,
    faStore,
    faQrcode,
    faHandHoldingDollar,
    faBoxesStacked,
    faCoins,
    faMagnifyingGlass,
    faUserPlus,
    faShieldHalved,
    faRobot,
    faLink,
    faLinkSlash,
    faXmark,
    faIdBadge,
    faLandmark,
    faAngleRight,
    faAngleLeft,
    faChevronUp,
    faChevronDown,
    faUserGear,
    faUserSecret,
    faEarthAmericas,
    faEllipsis,
    faGears,
    faRotateRight,
    faRotateLeft,
    faQuestionCircle,
    faMap
)

export const app = createApp(root)



app.use(createMetaManager())
app.use(vuetify)
app.use(msalPlugin)
app.use(router)
app.use(store)
app.use(i18n)

app.mixin(globalMixin)

axios.defaults.baseURL = import.meta.env.VITE_API_URL
axios.defaults.timeout = 330000 // milliseconds
axios.defaults.headers = { "VMIDNETWORK": "TRUE" }

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                console.log("401 on Axios request");
            }
            else if (error.response.status === 404) {
                console.log("404 on Axios request");
            }
            else if (error.response.status === 500){
                console.log("500 on Axios request");
            }
        }
        return Promise.reject(error);
    }
)

router.isReady().then(() => app.mount('#app'))